export default __webpack_public_path__ + "static/media/livet-som-elev-paa-slagteriskolen-with-subs.5d680b33.mp4";